import { Tooltip, TooltipContent, TooltipTrigger } from '@procureai/uix';
import { InfoIcon } from 'lucide-react';
import { ReactNode } from 'react';

import { SvbrgIntakeSupplierSource } from '@/generated/gql/graphql';

import { IntakeSupplierSourceChip } from './IntakeSupplierSourceChip';

export type IntakeSupplierSourceProps = {
  value: {
    source: SvbrgIntakeSupplierSource | null | undefined;
    reason: string | null | undefined;
  };
};

export const IntakeSupplierSource = ({ value }: IntakeSupplierSourceProps): ReactNode => {
  const renderReason = (reason: string) => {
    const lines = reason.split('\n');
    const lastLine = lines[lines.length - 1];
    const isUrl = /^(http|https):\/\/[^ "]+$/.test(lastLine);

    if (isUrl) {
      const text = lines.slice(0, -1).join('\n');
      return (
        <>
          {text}
          {text && '\n'}
          <a
            href={lastLine}
            target="_blank"
            rel="noopener noreferrer"
            className="underline break-all"
            onClick={(e) => e.stopPropagation()}
          >
            {lastLine}
          </a>
        </>
      );
    }
    return reason;
  };

  return (
    <div className="flex items-center space-x-2">
      <IntakeSupplierSourceChip value={value.source} />
      {value.reason && (
        <Tooltip>
          <TooltipTrigger render={<InfoIcon className="size-5" />} />
          <TooltipContent side="right" className="max-w-64 whitespace-pre-line">
            {renderReason(value.reason)}
          </TooltipContent>
        </Tooltip>
      )}
    </div>
  );
};
